import { Button, Form, Modal } from "antd";
import React, { useState, useEffect, useRef } from "react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import FormInput from "./FormInput";

const DEFAULT_CROP = { aspect: 1 / 1 };

const UploadWithCrop = ({
  onUpload,
  image,
  defaultAspect = DEFAULT_CROP.aspect,
  title = null,
  showAlt = true,
  required = false,
  form,
  name = "image",
}) => {
  const fileInputRef = useRef(null);
  const cropperRef = useRef(null);
  const [imageUrl, setImageUrl] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [croppedImage, setCroppedImage] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    setImageFile(image);
  }, [image]);

  const handleImageChange = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      setError(null);
      const newImage = event.target.files[0];

      const reader = new FileReader();
      reader.onload = (event) => {
        setImageUrl(event.target.result);
        setIsModalOpen(true);
      };
      reader.readAsDataURL(newImage);
      event.target.value = null;
    }
  };

  const handleCrop = () => {
    const cropper = cropperRef.current.cropper;
    const canvas = cropper.getCroppedCanvas();

    if (canvas) {
      const base64Image = canvas.toDataURL("image/webp");
      canvas.toBlob((blob) => {
        const webpBlobUrl = URL.createObjectURL(blob);
        setCroppedImage(webpBlobUrl);
        setImageFile(base64Image);
        form.setFieldsValue({ [name]: base64Image });
        form.validateFields([name]);
        if (onUpload) {
          const file = new File([blob], "cropped-image.webp", {
            type: "image/webp",
          });
          onUpload(base64Image);
        }
      }, "image/webp");
    }
  };

  const handleSubmit = () => {
    handleCrop();
    setIsModalOpen(false);
  };

  const handleModalCancel = () => {
    setIsModalOpen(false);
    setImageUrl(null);
    setCroppedImage(null);
  };

  useEffect(() => {
    return () => {
      if (imageUrl) {
        URL.revokeObjectURL(imageUrl);
      }
      if (croppedImage) {
        URL.revokeObjectURL(croppedImage);
      }
    };
  }, [imageUrl, croppedImage]);

  return (
    <Form.Item
      name={name}
      rules={[
        { required, message: "Please upload an image" },
      ]}
    >
    <div style={{ width: "100%" }}>
      <input
        ref={fileInputRef}
        accept=".jpeg, .jpg, .png, .webp"
        id="fileInput"
        type="file"
        onChange={handleImageChange}
        style={{ display: "none" }}
      />
      <div className="upload-file">
        <div className="upload-file_heading">
          <h2>{title ?? "Image"}</h2>
          {imageFile && (
            <Button onClick={() => fileInputRef.current.click()}>Edit</Button>
          )}
        </div>
        {imageFile ? (
          <>
            <div className="upload-file_image">
              <img src={imageFile} alt="cropped-image" />
            </div>
            {showAlt && (
              <FormInput
                label="Image Alt Text"
                name="altText"
                placeholder="Enter image alt text"
              />
            )}
          </>
        ) : (
          <>
            <div className="upload-file_container">
              <Button onClick={() => fileInputRef.current.click()}>
                Add image
              </Button>
              <p>or drop an image to upload</p>
            </div>
            {required && error && <p className="error-message">{error}</p>}
          </>
        )}
      </div>
      {imageUrl && (
        <Modal
          title="Crop Image"
          open={isModalOpen}
          onCancel={handleModalCancel}
          maskClosable={false}
          width={700}
          footer={[
            <Button key="back" onClick={handleModalCancel}>
              Cancel
            </Button>,
            <Button key="submit" type="primary" onClick={handleSubmit}>
              Submit
            </Button>,
          ]}
        >
          <div className="upload-image">
            <Cropper
              ref={cropperRef}
              src={imageUrl}
              style={{ height: 400, width: "100%" }}
              aspectRatio={defaultAspect}
              guides={true}
              viewMode={1}
              autoCropArea={1}
              zoomable={false}
            />
          </div>
        </Modal>
      )}
    </div></Form.Item>
  );
};

export default UploadWithCrop;
